<template>
  <v-snackbar v-model="snacking" :color="type" :timeout="3000" bottom left>
    {{ text }}
    <v-btn flat @click="$emit('unsnack')">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: String,
      required: false,
      default: "Hello"
    }
  },
  computed: {
    snacking: {
      get() {
        return !!this.type;
      },
      set(val) {
        !val && this.$emit("unsnack");
      }
    }
  }
};
</script>
